import './Modal.scss';
import Component from './Modal.js';
export default Component;